import { render, staticRenderFns } from "./ProductModule.vue?vue&type=template&id=f27ac376&"
import script from "./ProductModule.vue?vue&type=script&lang=js&"
export * from "./ProductModule.vue?vue&type=script&lang=js&"
import style0 from "./ProductModule.vue?vue&type=style&index=0&id=f27ac376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports